import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment
} from "semantic-ui-react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authLogin } from "../store/actions/auth";

const LoginForm = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, error, token } = useSelector(state => state.auth);

  useEffect(() => {
    if (token) {
      navigate("/"); // redirect after successful login
    }
  }, [token, navigate]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(authLogin(formData.username, formData.password));
  };

  return (
    <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" color="teal" textAlign="center">
          Log-in to your account
        </Header>
        {error && <p>{error.message}</p>}

        <Form size="large" onSubmit={handleSubmit}>
          <Segment stacked>
            <Form.Input
              onChange={handleChange}
              value={formData.username}
              name="username"
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Username"
            />
            <Form.Input
              onChange={handleChange}
              value={formData.password}
              name="password"
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
            />
            <Button
              color="teal"
              fluid
              size="large"
              loading={loading}
              disabled={loading}
            >
              Login
            </Button>
          </Segment>
        </Form>

        <Message>
          New to us? <NavLink to="/signup">Sign Up</NavLink>
        </Message>
      </Grid.Column>
    </Grid>
  );
};

export default LoginForm;